var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('document', 'documentElement');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/html.js
// module id = 888
// module chunks = 1 2 3 4